import { Component, Inject, OnInit } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { map, Observable, of } from 'rxjs';

import { WizardService } from '@sondermind/flows-host';
import {
  FlowsLaunchDarklyFeatureFlags,
  FlowsLaunchDarklyService,
  LAUNCH_DARKLY_SERVICE
} from '@sondermind/launch-darkly';
import { ResponseUpdateItem } from '@sondermind/utilities/models-flows';

import { IMultiSectionCheckboxConfig } from '../basic-form/model';
import { IntakeStepComponent } from '../intake-step.component';

@Component({
  selector: 'multi-section-checkbox',
  templateUrl: './multi-section-checkbox.component.html',
  styleUrls: ['./multi-section-checkbox.component.scss']
})
export class MultiSectionCheckboxComponent extends IntakeStepComponent<IMultiSectionCheckboxConfig> implements OnInit {
  multiSectionCheckboxForm: FormGroup = this.fb.group({});

  overrideDesiredAvailability$: Observable<boolean> = of(false);

  constructor(
    private fb: FormBuilder,
    wizard: WizardService,
    @Inject(LAUNCH_DARKLY_SERVICE)
    private launchDarklyService: FlowsLaunchDarklyService,
  ) {
    super(wizard);
  }

  ngOnInit(): void {
    this.initForm();

    this.overrideDesiredAvailability$ = this.launchDarklyService.ldFlag$.pipe(
      map((ldFlags) => {
        const removeInPersonFlag = ldFlags[FlowsLaunchDarklyFeatureFlags.REMOVE_IN_PERSON] as boolean;
        const isCorrectFlowAndStep = this.response.slug === 'matching-flow-base'
          && this.component.slug === 'desired-availability';

        return removeInPersonFlag && isCorrectFlowAndStep;
      })
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }

  initForm(): void {
    this.config.form.forEach((item) => {
      const sectionFormGroup = this.fb.group({});

      item.sections.forEach((section) => {
        section.options.forEach((option) => {
          const hasValue = (this.data[item.name] as string[] ?? []).includes(option.value);
          sectionFormGroup.addControl(option.value, this.fb.control(hasValue));
        });
      });
      this.multiSectionCheckboxForm.addControl(item.name, sectionFormGroup);
    });
  }

  onSubmit(): ResponseUpdateItem[] {
    return this.config.form.map((item) => {
      const formValues: Record<string, boolean> = this.multiSectionCheckboxForm.value[item.name];

      return {
        human: item.name,
        key: item.name,
        value: Object.keys(formValues).filter((key) => formValues[key])
      };
    });
  }
}
